import { PDTabla } from '../models/PDTabla';
import { DocumentoDet } from '../models/DocumentoDet';
import { CargarDatosPlantilla, NumIdCatTipoPDRedSoc, NumIdCatNombrPlantRSOC, NumIdCatNomPlantGenRSOC, CodTipoFichaFUR, CodSubTipoFichaOFI, CodSubTipoFichaFUR, NumIdTipCatCampPlantOtros, NumIdCatTipoPDEmail, NumIdCatNombrPlantEmail, NumIdCatNomPlantGenEmail, NumIdCatTipoPDMonit, NumIdCatNombrPlantMonit, NumIdCatNomPlantGenMonit, NumIdCatTipoPDPrensa, NumIdCatNomPlantGenPrensa, NumIdCatNomPlantPrensa, NumIdCatTipoPDMP, NumIdCatNomPlantMP, NumIdCatNomPlantGenMP, NumIdCatTipoPDApp, NumIdCatNomPlantGenApp, NumIdCatNomPlantApp, NumIdCatTipoPDRFiscal, NumIdCatNomPlantRFiscal, NumIdCatNomPlantGenRFiscal, NumIdCatTipoPDEmpre, NumIdCatNomPlantEmpre, NumIdCatNomPlantGenEmpre, NumIdCatTipoPDAudien, NumIdCatNombrPlantAudien, NumIdCatNomPlantGenAudien, NumIdCatTipoPDPostula, NumIdCatNomPlantGenPostula, NumIdCatNombrPlantPostula, NumIdCatTipoPDBD, NumIdCatNombrPlantBD, NumIdCatNomPlantGenBD, NumIdCatTipoPDServ, NumIdCatNombrPlantServ, NumIdCatNomPlantGenServ, NumIdCatTipoPDExp, NumIdCatNombrPlantExp, NumIdCatNomPlantGenExp, CodTipoExpDetREF, CodTipoExpDetDES, NumIdCatTipoPD, NumIdCatNombrPlantFW, NumIdCatDocGenFW, recupDscTipoInstancia } from './variables';
import { Observable } from 'rxjs/internal/Observable';
import { General } from '../models/General';
import { CatalogoService } from '../services/Catalogo.service';
import { Injectable } from '@angular/core';
import { PDFila } from '../models/PDFila';
import { ExpedienteDet } from '../models/ExpedienteDet';
import { Denunciado } from '../models/Denunciado';
import { DenunciadoXFicha } from '../models/DenunciadoXFicha';
import { FichaXInstancia } from '../models/FichaXInstancia';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })

export class ParametroPlantillaDocumento {

    constructor(protected catalogoService: CatalogoService) { }

    recupParamPlantillaDoc(numCaso: number, numIdTipCatCampos?: number) {

        // console.log("======recupParamPlantillaDoc");

        numIdTipCatCampos = (numIdTipCatCampos ? numIdTipCatCampos : NumIdTipCatCampPlantOtros);

        let vNumIdNomPlantilla: number = null;
        let vNumIdCatNomPlant: number = null;
        let vNumIdCatNomGenPlant: number = null;
        // var vNumIdTipCatCampos:number = null;
        const vObjReturn: General = new General();

        // vNumIdTipCatCampos = NumIdTipCatCampPlantOtros;

        switch (numCaso) {
        case 1:

            vNumIdNomPlantilla = NumIdCatTipoPDEmail;

            vNumIdCatNomPlant = NumIdCatNombrPlantEmail;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenEmail;

            break;

        case 2:

            vNumIdNomPlantilla = NumIdCatTipoPDRedSoc;

            vNumIdCatNomPlant = NumIdCatNombrPlantRSOC;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenRSOC;

            break;

        case 3:

            vNumIdNomPlantilla = NumIdCatTipoPDPrensa;

            vNumIdCatNomPlant = NumIdCatNomPlantPrensa;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenPrensa;

            break;

        case 4:

            vNumIdNomPlantilla = NumIdCatTipoPDMP;

            vNumIdCatNomPlant = NumIdCatNomPlantMP;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenMP;

            break;

        case 5:

            vNumIdNomPlantilla = NumIdCatTipoPDApp;

            vNumIdCatNomPlant = NumIdCatNomPlantApp;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenApp;

            break;

        case 6:

            vNumIdNomPlantilla = NumIdCatTipoPDRFiscal;

            vNumIdCatNomPlant = NumIdCatNomPlantRFiscal;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenRFiscal;

            break;

        case 7:

            vNumIdNomPlantilla = NumIdCatTipoPDEmpre;

            vNumIdCatNomPlant = NumIdCatNomPlantEmpre;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenEmpre;

            break;

        case 8:

            vNumIdNomPlantilla = NumIdCatTipoPDMonit;

            vNumIdCatNomPlant = NumIdCatNombrPlantMonit;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenMonit;

            break;

        case 9:

            vNumIdNomPlantilla = NumIdCatTipoPDAudien;

            vNumIdCatNomPlant = NumIdCatNombrPlantAudien;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenAudien;

            break;

        case 10:

            vNumIdNomPlantilla = NumIdCatTipoPDPostula;

            vNumIdCatNomPlant = NumIdCatNombrPlantPostula;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenPostula;

            break;

        case 11:

            vNumIdNomPlantilla = NumIdCatTipoPDBD;

            vNumIdCatNomPlant = NumIdCatNombrPlantBD;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenBD;

            break;

        case 12:

            vNumIdNomPlantilla = NumIdCatTipoPDServ;

            vNumIdCatNomPlant = NumIdCatNombrPlantServ;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenServ;

            break;

        case 13:

            vNumIdNomPlantilla = NumIdCatTipoPDExp;

            vNumIdCatNomPlant = NumIdCatNombrPlantExp;
            vNumIdCatNomGenPlant = NumIdCatNomPlantGenExp;

            break;
        case 14:

            vNumIdNomPlantilla = NumIdCatTipoPD;

            vNumIdCatNomPlant = NumIdCatNombrPlantFW;
            vNumIdCatNomGenPlant = NumIdCatDocGenFW;

            break;

        default:
            break;
        }


        const returnObservable = new Observable<General>(observer => {

            this.catalogoService.listarCatalogo(vNumIdNomPlantilla).subscribe(
                data => {

                //   this.strDscNombrPlantilla = data.find(x=>x.ncatalogoId == vNumIdCatNomPlant).ccatalogoDsc;
                //   this.strDscNomArchivoGen = data.find(x=>x.ncatalogoId == vNumIdCatNomGenPlant).ccatalogoDsc;
                    vObjReturn.dscCampo1 = data.find(x => x.ncatalogoId == vNumIdCatNomPlant).ccatalogoDsc;
                    vObjReturn.dscCampo2 = data.find(x => x.ncatalogoId == vNumIdCatNomGenPlant).ccatalogoDsc;

                    // console.log("=========numIdTipCatCampos");
                    // console.log(numIdTipCatCampos);

                    this.catalogoService.listarCatalogo(numIdTipCatCampos).subscribe(
                    data => {

                        vObjReturn.listaPdDatos = CargarDatosPlantilla(data);

                        // console.log("============vObjReturn.listaPdDatos");
                        // console.log(vObjReturn.listaPdDatos);

                        observer.next(vObjReturn);

                    });

                });

        });

        return returnObservable;


    }



}

export function GenerarPDFilas(dato: string, listFila: PDFila[]) {

    let vItemFila: PDFila = null;

    vItemFila = new PDFila();
    vItemFila.valor = dato.trim();

    listFila.push(vItemFila);

    return listFila;

  }


export function FiltrarListEvidencias(listDocumentoDet: DocumentoDet[]) {

    return listDocumentoDet.filter(x => x.cdocumentoCodtipo == CodTipoFichaFUR && x.cdocumentoCodsubtipo == CodSubTipoFichaFUR);

}



export function FiltrarListExpedienteRef(listExp: ExpedienteDet[]) {

    return listExp.filter(x => x.cexpdetCodtipo == CodTipoExpDetREF);

}

export function FiltrarListExpedienteDest(listExp: ExpedienteDet[]) {

    return listExp.filter(x => x.cexpdetCodtipo == CodTipoExpDetDES);

}


export function RecuperarGrillasPD(posicion: string, lista: any[], numCaso: number, listGrilla?: PDTabla[], itemGrilla?: PDTabla) {

    let vListDocumentoDet: DocumentoDet[] = null;
    let vListExp: ExpedienteDet[] = null;
    let vListDenunciado: DenunciadoXFicha[] = null;
    let vListFichaPorInst: FichaXInstancia[] = null;

    itemGrilla = (itemGrilla ? itemGrilla : new PDTabla());
    listGrilla = (listGrilla ? listGrilla : []);

    switch (numCaso) {
        case 1: // EVIDENCIAS

            vListDocumentoDet = lista;

            vListDocumentoDet = FiltrarListEvidencias(vListDocumentoDet); // listDocumentoDet.filter(x=>x.cdocumentoCodtipo == CodTipoFichaFUR && x.cdocumentoCodsubtipo == CodSubTipoFichaFUR);

            itemGrilla = GenerarPDGrillas(itemGrilla, vListDocumentoDet, '4', posicion);

            vListDocumentoDet.forEach((element, index) => {

                index ++;

                itemGrilla.filas = GenerarPDFilas(index.toString(), itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.cdocumentoDscnombre, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.strDdocumentoFchreg, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas('Registrado', itemGrilla.filas);

            });

            break;

        case 2: // EXP REF

            vListExp = lista;

            vListExp = FiltrarListExpedienteRef(vListExp); // listDocumentoDet.filter(x=>x.cdocumentoCodtipo == CodTipoFichaFUR && x.cdocumentoCodsubtipo == CodSubTipoFichaFUR);

            itemGrilla = GenerarPDGrillas(itemGrilla, vListExp, '6', posicion);

            vListExp.forEach((element, index) => {

                index ++;

                itemGrilla.filas = GenerarPDFilas(index.toString(), itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.cexpdetCodanho, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.nexpdetIdtipdoc.toString(), itemGrilla.filas); // PENDIENTE DSC SERVICIO
                itemGrilla.filas = GenerarPDFilas(element.cexpdetNrodoc, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.cexpdetNroexp, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.strDexpdetFecha, itemGrilla.filas); // PENDIENTE DSC SERVICIO

                // itemGrilla.filas = GenerarPDFilas(element.,itemGrilla.filas);
                // itemGrilla.filas = GenerarPDFilas("Registrado",itemGrilla.filas);

            });

            break;

        case 3: // EXP DEST

            vListExp = lista;

            vListExp = FiltrarListExpedienteDest(vListExp); // listDocumentoDet.filter(x=>x.cdocumentoCodtipo == CodTipoFichaFUR && x.cdocumentoCodsubtipo == CodSubTipoFichaFUR);

            itemGrilla = GenerarPDGrillas(itemGrilla, vListExp, '7', posicion);

            vListExp.forEach((element, index) => {

                index ++;

                itemGrilla.filas = GenerarPDFilas(index.toString(), itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.cexpdetCoduno, itemGrilla.filas); // PENDIENTE DSC SERVICIO
                itemGrilla.filas = GenerarPDFilas(element.cexpdetCodlocal, itemGrilla.filas); // PENDIENTE DSC SERVICIO
                itemGrilla.filas = GenerarPDFilas(element.cexpdetCodpersonal, itemGrilla.filas); // PENDIENTE DSC SERVICIO
                itemGrilla.filas = GenerarPDFilas(element.cexpdetCodresp, itemGrilla.filas); // PENDIENTE DSC SERVICIO
                itemGrilla.filas = GenerarPDFilas(element.cexpdetDscindica, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.nexpdetIdprioridad.toString(), itemGrilla.filas); // PENDIENTE DSC SERVICIO

            });

            break;

        case 4: // LISTA DENUNCIADO

            vListDenunciado = lista;

            // vItemGrilla = this._generarPDGrillas(vItemGrilla,vListDenunciado,"7","6");

            itemGrilla = GenerarPDGrillas(itemGrilla, vListDenunciado, '7', posicion);

            vListDenunciado.forEach((element, index) => {

                index ++;

                itemGrilla.filas = GenerarPDFilas(index.toString(), itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.denunciado.cdenunciadoNrodoc, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.denunciado.cdenunciadoNombres, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.denunciado.cdenunciadoApepaterno, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.denunciado.cdenunciadoApematerno, itemGrilla.filas);

                itemGrilla.filas = GenerarPDFilas('', itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.denunciado.cdenunciadoFlgpermentidad, itemGrilla.filas);

            });

            break;

        case 5: // LISTA INSTANCIAS

            vListFichaPorInst = lista;

            itemGrilla = GenerarPDGrillas(itemGrilla, vListFichaPorInst, '6', posicion);

            // vItemGrilla = this._generarPDGrillas(vItemGrilla,vListFichaPorInst,"6","12");

            vListFichaPorInst.forEach((element, index) => {

                index ++;

                itemGrilla.filas = GenerarPDFilas(index.toString(), itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(recupDscTipoInstancia(element.cfichaxinstanCodtipo), itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.entidad.centNombre, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.cfichaxinstanNrodoc, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.strDfichaxinstanFechaprest, itemGrilla.filas);
                itemGrilla.filas = GenerarPDFilas(element.estado.ccatalogoDsc, itemGrilla.filas);

            });

            break;

        default:
            break;
    }

    listGrilla.push(itemGrilla);

    return listGrilla;

}

// export function PDGenerarGrillaExpRef(posicion:string,listDocumentoDet:DocumentoDet[],listGrilla?:PDTabla[],itemGrilla?:PDTabla)
// {

//     listDocumentoDet = FiltrarListEvidencias(listDocumentoDet);//listDocumentoDet.filter(x=>x.cdocumentoCodtipo == CodTipoFichaFUR && x.cdocumentoCodsubtipo == CodSubTipoFichaFUR);

//     itemGrilla = (itemGrilla ? itemGrilla : new PDTabla());
//     listGrilla = (listGrilla ? listGrilla : []);

//     itemGrilla = GenerarPDGrillas(itemGrilla,listDocumentoDet,"4",posicion);

//     listDocumentoDet.forEach((element,index) => {

//       index ++;

//       itemGrilla.filas = GenerarPDFilas(index.toString(),itemGrilla.filas);
//       itemGrilla.filas = GenerarPDFilas(element.cdocumentoDscnombre,itemGrilla.filas);
//       itemGrilla.filas = GenerarPDFilas(element.strDdocumentoFchreg,itemGrilla.filas);
//       itemGrilla.filas = GenerarPDFilas("Registrado",itemGrilla.filas);


//     });

//     listGrilla.push(itemGrilla);

//     return listGrilla;

// }

export function RecupUrlOficio(lista: DocumentoDet[]) {

    let vDscReturn = '';
    const vItem = lista.find(x => x.cdocumentoCodtipo == CodTipoFichaFUR && x.cdocumentoCodsubtipo == CodSubTipoFichaOFI);

    vDscReturn = (vItem ? vItem.cdocumentoDscurl : '');

    return vDscReturn;

}




export function GenerarPDGrillas(itemGrilla: PDTabla, lista: any, col: string, ubic: string) {

    itemGrilla = new PDTabla();

    itemGrilla.columnas = col;
    itemGrilla.nombre = '0';
    itemGrilla.ubicacion = ubic;
    itemGrilla.nuevasFilas = lista.length.toString();

    itemGrilla.filas = [];

    return itemGrilla;

  }


export function ValidarFechaLength(fecha: string) {

    const vCantCadena = fecha.length;

    if (vCantCadena > 10) {

        fecha = fecha.substr(vCantCadena - 10);

    }

    return fecha;

  }

//   export function loadFormAssets() {
//     return new Promise(resolve => {

//       const scriptElement = document.createElement('script');
//       scriptElement.src = "assets/js/captcha.js";
//       scriptElement.onload = resolve;
//       document.body.appendChild(scriptElement);

//       const scriptElement1 = document.createElement('script');
//       scriptElement1.src = "assets/js/document-captcha.js";
//       scriptElement1.onload = resolve;
//       scriptElement1.async = true;
//       scriptElement1.defer = true;
//       document.body.appendChild(scriptElement1);

//     });
//   }

export function errorHandler(error: HttpErrorResponse) {
    console.clear();
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.

      console.log('Error al conectar con el servicio');
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log('Error al conectar con el servicio');
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

//   export function cargarCaptcha(){

//     try {

//         setTimeout(() => {

//           loadFormAssets().then(() => {console.log("Script Loaded");})
//           .catch(() => {

//             console.log("Script Problem");

//           });

//         }, 600);

//       } catch (e) {

//         setTimeout(() => {

//           loadFormAssets().then(() => {console.log("Script Loaded");})
//           .catch(() => {

//             console.log("Script Problem");

//           });

//         }, 600);

//      }

//     }



